import {Credentials} from '../models/auth/credentials.model';

export namespace Auth {
  export class Login {
    static readonly type = '[Auth] Login';

    constructor(public payload: Credentials) {
    }
  }

  export class Logout {
    static readonly type = '[Auth] Logout';

    constructor() {
    }
  }

  export class GetOrganizationModules {
    static readonly type = '[Auth] GetOrganizationModules';

    constructor() {
    }
  }

  export class ClearState {
    static readonly type = 'ClearState';

    constructor() {
    }
  }
}
